"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractSubscriptionDetails = exports.isAicpaMember = exports.checkFlpProductRenewal = exports.checkUserAicpaRegularMember = exports.isTwoYearRatePlan = exports.isSubscription = exports.findTerritory = exports.getZuoraRatePlanOverride = exports.getAllPaymentOptionsCheck = void 0;
const mxp_schemas_1 = require("mxp-schemas");
const checkout_1 = require("../checkout");
const TWO_YEAR_RATE_PLANS = [];
/**
 * @param option - payment option to be used for a zuora order [ZuoraTypes.PaymentOption]
 * @returns object of key:value "is" booleans to cater for different payment options available in zuora. Defaults to regular payment = true if option is undefined
 */
const getAllPaymentOptionsCheck = (option) => {
    return option
        ? {
            isRegularPayment: option === mxp_schemas_1.ZuoraTypes.PaymentOption.REGULAR,
            isOfflinePayment: option === mxp_schemas_1.ZuoraTypes.PaymentOption.OFFLINE,
            isNoPayment: option === mxp_schemas_1.ZuoraTypes.PaymentOption.NO_PAYMENT,
            isCheckPayment: option === mxp_schemas_1.ZuoraTypes.PaymentOption.CHECK,
            isRefund: option === mxp_schemas_1.ZuoraTypes.PaymentOption.REFUND,
        }
        : {
            isRegularPayment: true,
            isOfflinePayment: false,
            isNoPayment: false,
            isCheckPayment: false,
            isRefund: false,
        };
};
exports.getAllPaymentOptionsCheck = getAllPaymentOptionsCheck;
const getZuoraRatePlanOverride = (name, productType, commonConfig, log, isCimaOverride) => {
    try {
        const overrideKey = isCimaOverride
            ? commonConfig.get(`cimaZuoraOverride.${productType}.${name}`)
            : commonConfig.get(`zuoraOverride.${productType}.${name}`);
        log.debug(`isCimaOverride: ${JSON.stringify(isCimaOverride)}`);
        if (overrideKey)
            log.info(`Overridekey key: ${overrideKey} found for ${name}. Product type ${productType}`);
        return overrideKey || null;
    }
    catch (ex) {
        // fail silently, means ZRP override is not defined
        log.info(`No Overridekey found for ${name}. Product type ${productType}`);
        return null;
    }
};
exports.getZuoraRatePlanOverride = getZuoraRatePlanOverride;
const findTerritory = (billingCountry, log) => {
    var _a;
    const countryCodeISOAlpha3 = (0, checkout_1.resolveCountryNamesToISOAlpha3CodeWithFallbacks)(billingCountry, log) || billingCountry;
    const territory = (_a = checkout_1.COUNTRIES_LIST.find(country => country.ISOAlpha3Code === countryCodeISOAlpha3)) === null || _a === void 0 ? void 0 : _a.territory;
    if (!territory) {
        log.warn(`Couldn't find territory for: ${billingCountry}`);
        return '00000000';
    }
    return territory;
};
exports.findTerritory = findTerritory;
const isSubscription = (cartItem) => {
    return (cartItem.productDetails.productType === mxp_schemas_1.Product.ProductType.SUBSCRIPTION ||
        cartItem.productDetails.productType === mxp_schemas_1.Product.ProductType.MEMBERSHIP ||
        cartItem.productDetails.productType === mxp_schemas_1.Product.ProductType.CREDENTIAL ||
        cartItem.productDetails.productType === mxp_schemas_1.Product.ProductType.SECTION ||
        cartItem.productDetails.productType === mxp_schemas_1.Product.ProductType.FLP ||
        cartItem.productDetails.isPhysicalProductSubscription ||
        cartItem.productDetails.isManualSubscription);
};
exports.isSubscription = isSubscription;
const isTwoYearRatePlan = (ratePlanLabel, log) => {
    const isTwoYears = TWO_YEAR_RATE_PLANS.includes(ratePlanLabel);
    log.debug(`ratePlanLabel: ${ratePlanLabel}, isTwoYearRatePlan: ${isTwoYears}`);
    return isTwoYears;
};
exports.isTwoYearRatePlan = isTwoYearRatePlan;
const checkUserAicpaRegularMember = (activeMembershipSubscription) => {
    var _a, _b, _c, _d, _e, _f;
    const hasActiveMembership = (activeMembershipSubscription === null || activeMembershipSubscription === void 0 ? void 0 : activeMembershipSubscription.productType) === mxp_schemas_1.Product.ProductType.MEMBERSHIP;
    const hasActiveAicpaMember = ((_c = (_b = (_a = activeMembershipSubscription === null || activeMembershipSubscription === void 0 ? void 0 : activeMembershipSubscription.variant) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.membershipBody) === null || _c === void 0 ? void 0 : _c.key) === mxp_schemas_1.Product.ProductMembershipBody.AICPA;
    const hasActiveAicpaRegularMember = ((_f = (_e = (_d = activeMembershipSubscription === null || activeMembershipSubscription === void 0 ? void 0 : activeMembershipSubscription.variant) === null || _d === void 0 ? void 0 : _d.attributes) === null || _e === void 0 ? void 0 : _e.membershipKey) === null || _f === void 0 ? void 0 : _f.key) === mxp_schemas_1.User.MembershipTypes.REGULAR;
    return hasActiveMembership && hasActiveAicpaMember && hasActiveAicpaRegularMember;
};
exports.checkUserAicpaRegularMember = checkUserAicpaRegularMember;
const checkFlpProductRenewal = (isFlpRenewal, activeFLPSubscription, flpLineItem, isRenewalButtonClicked) => {
    const hasFlpActiveAndInCart = [activeFLPSubscription, flpLineItem].every((product) => (product === null || product === void 0 ? void 0 : product.productType) === mxp_schemas_1.Product.ProductType.FLP);
    return [isFlpRenewal, hasFlpActiveAndInCart, isRenewalButtonClicked].every((flag) => flag);
};
exports.checkFlpProductRenewal = checkFlpProductRenewal;
const isAicpaMember = (activeMembershipSubscription) => {
    var _a, _b, _c;
    return (activeMembershipSubscription === null || activeMembershipSubscription === void 0 ? void 0 : activeMembershipSubscription.productType) === mxp_schemas_1.Product.ProductType.MEMBERSHIP &&
        ((_c = (_b = (_a = activeMembershipSubscription === null || activeMembershipSubscription === void 0 ? void 0 : activeMembershipSubscription.variant) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.membershipBody) === null || _c === void 0 ? void 0 : _c.key) === mxp_schemas_1.Product.ProductMembershipBody.AICPA;
};
exports.isAicpaMember = isAicpaMember;
const extractSubscriptionDetails = (activeMembershipSubscription) => {
    const isAutoRenewEnabled = activeMembershipSubscription === null || activeMembershipSubscription === void 0 ? void 0 : activeMembershipSubscription.autoRenewEnabled;
    const isAutoRenewable = activeMembershipSubscription === null || activeMembershipSubscription === void 0 ? void 0 : activeMembershipSubscription.isAutoRenewable;
    const activeSubscriptionNumber = activeMembershipSubscription === null || activeMembershipSubscription === void 0 ? void 0 : activeMembershipSubscription.subscriptionNumber;
    const isUserActiveMember = [mxp_schemas_1.Product.ProductType.MEMBERSHIP, mxp_schemas_1.Product.ProductType.FLP].includes(activeMembershipSubscription === null || activeMembershipSubscription === void 0 ? void 0 : activeMembershipSubscription.productType) && (activeMembershipSubscription === null || activeMembershipSubscription === void 0 ? void 0 : activeMembershipSubscription.subscriptionStatus) === mxp_schemas_1.Product.ZuoraSubscriptionStatus.ACTIVE;
    return { isAutoRenewEnabled, isAutoRenewable, activeSubscriptionNumber, isUserActiveMember };
};
exports.extractSubscriptionDetails = extractSubscriptionDetails;
//# sourceMappingURL=index.js.map